/**
 * Translations.
 */
export default {
  ACTION: {
    CANCEL: 'Cancelar',
    CONFIRM: 'Confirmar',
    SAVE: 'Gravar',
    SEARCH: 'Procurar'
  },
  ERROR: {},
  HEADER: {
    EMAIL: 'E-mail',
    END_DATE: 'Data fim',
    MEMBER_ID: 'ID Sócio',
    NAME: 'Nome'
  },
  LABEL: {
    ALLOW_ADD_MEMBERS: 'Permite adicionar sócios',
    CREATE_MEMBER: 'Adicionar sócio',
    DELETE_MEMBER_MODAL_TITLE: 'Eliminar sócio',
    EDIT_MEMBER: 'Editar sócio',
    EMAIL: 'E-mail',
    END_DATE: 'Data fim',
    MEMBERS: 'Sócios',
    NAME: 'Nome',
    NO: 'Não',
    YES: 'Sim'
  },
  SENTENCE: {
    DELETE_MEMBER_TEXT: 'Tem a certeza que deseja eliminar o sócio?',
    NO_MEMBER_NAME_EMAIL: 'Sem nome e/ou e-mail',
    NO_MEMBER_NAME_EMAIL_DETAIL: 'Coloque informação de nome e/ou e-mail',
    NO_ROWS_MEMBERS: 'Sem sócios',
    NO_ROWS_MEMBERS_DESCRIPTION: 'Altere os critérios de pesquisa'
  },
  SUCCESS: {
    MEMBER_DELETED: 'Sócio eliminado com sucesso',
    MEMBER_DETAILS_SAVED: 'Sócio guardado com sucesso',
    SUCCESS: 'Sucesso'
  },
  TOOLTIP: {
    EDIT_MEMBER: 'Editar Sócio',
    EMAIL: 'E-mail',
    END_DATE: 'Data fim',
    MEMBER_ID: 'ID Sócio',
    NAME: 'Nome',
    REMOVE_MEMBER: 'Remover Sócio'
  }
};
